import type { SeasonOption } from '@/lib/dateUtils'

interface SeasonSelectorProps {
  value: string // e.g. "2024-25"
  options: SeasonOption[]
  onChange: (season: SeasonOption) => void
}

export function SeasonSelector({ value, options, onChange }: SeasonSelectorProps) {
  return (
    <select
      value={value}
      onChange={(e) => {
        const season = options.find((o) => o.label === e.target.value)
        if (season) onChange(season)
      }}
      className="rounded-lg bg-pitch-800 border border-pitch-700 text-sm text-slate-300 px-3 py-1.5 focus:outline-none focus:ring-1 focus:ring-accent/50 cursor-pointer"
    >
      {options.map((opt) => (
        <option key={opt.label} value={opt.label}>
          {opt.label}
        </option>
      ))}
    </select>
  )
}
